import * as S from './WBSelect.styles';

import React from 'react';
import WBIcon from './WBIcon';
import {useOnMouseDownOutside} from '../../util/dom';
import WBMenu, {
  WBMenuOption,
  getOptionDisplayName,
  WBMenuOnSelectHandler,
} from './WBMenu';
import WBPopup from './WBPopup';
import makeComp from '../../util/profiler';

export interface WBSelectProps {
  className?: string;
  popupStyle?: React.CSSProperties;
  value: string | number;
  options: WBMenuOption[];
  typeable?: boolean;
  menuWidth?: number;
  menuBackgroundColor?: string;
  autoMenuWidth?: boolean;
  disabled?: boolean;
  onSelect: WBMenuOnSelectHandler;
}

const WBSelect: React.FC<WBSelectProps> = makeComp(
  props => {
    const [rect, setRect] = React.useState<DOMRect | undefined>();
    const [open, setOpen] = React.useState(false);
    const [inputFocused, setInputFocused] = React.useState(false);
    const [defaultWidth, setDefaultWidth] = React.useState(0);
    const [
      selectedElement,
      setSelectedElement,
    ] = React.useState<HTMLDivElement | null>(null);
    const [popupEl, setPopupEl] = React.useState<HTMLDivElement | null>(null);
    const onClickOutside = React.useCallback(() => {
      setOpen(false);
    }, []);

    let menuX = 0;
    let menuY = 0;
    if (rect != null) {
      menuX = rect.left;
      menuY = rect.top + rect.height / 2;
    }

    useOnMouseDownOutside([popupEl], onClickOutside);
    const selectedOption = props.options.find(opt => opt.value === props.value);

    return (
      <>
        {props.typeable ? (
          <S.TypeableWrapper
            ref={node => {
              if (node) {
                setDefaultWidth(node.offsetWidth);
              }
            }}
            open={open && !props.disabled}
            inputFocused={inputFocused && !props.disabled}
            className={props.className}
            onMouseDown={e => {
              setRect(e.currentTarget.getBoundingClientRect());
            }}>
            <S.StyledAutoCompletingInput
              options={props.options.map(opt => getOptionDisplayName(opt))}
              value={selectedOption?.name}
              disabled={props.disabled}
              onSelect={val => {
                const selected = props.options.find(
                  opt => getOptionDisplayName(opt) === val
                );
                if (selected != null) {
                  props.onSelect(selected.value, {option: selected});
                }
              }}
              onFocus={() => setInputFocused(true)}
              onBlur={() => setInputFocused(false)}
            />
            <S.CaretWrapper onMouseDown={() => setOpen(o => !o)}>
              <WBIcon name="next" />
            </S.CaretWrapper>
          </S.TypeableWrapper>
        ) : (
          <S.BasicWrapper
            ref={node => {
              if (node) {
                setDefaultWidth(node.offsetWidth);
              }
            }}
            tabIndex={props.disabled ? undefined : 0}
            // onMouseDown={e => e.preventDefault()}
            // onFocus={e => {
            //   setRect(e.currentTarget.getBoundingClientRect());
            //   setOpen(true);
            // }}
            // onBlur={() => {
            //   setOpen(false);
            // }}
            onKeyDown={e => {
              if (e.keyCode === 38 || e.keyCode === 40 /* up or down */) {
                if (!open) {
                  setRect(e.currentTarget.getBoundingClientRect());
                  setOpen(true);
                }
              }
            }}
            open={open && !props.disabled}
            onMouseDown={e => {
              setRect(e.currentTarget.getBoundingClientRect());
              setOpen(o => !o);
            }}
            className={props.className}>
            <S.DisplayedValue>
              {selectedOption == null
                ? props.value
                : getOptionDisplayName(selectedOption)}
            </S.DisplayedValue>
            <WBIcon name="next" />
          </S.BasicWrapper>
        )}
        {open && !props.disabled && (
          <WBPopup
            style={props.popupStyle}
            x={menuX}
            y={menuY}
            direction={'center right'}
            ref={node => setPopupEl(node)}
            elementToPosition={selectedElement}>
            <WBMenu
              backgroundColor={props.menuBackgroundColor}
              width={
                props.autoMenuWidth
                  ? undefined
                  : props.menuWidth ?? defaultWidth
              }
              selected={props.value}
              options={props.options}
              onSelect={(val, extra) => {
                console.log('select');
                setOpen(false);
                props.onSelect(val, extra);
              }}
              onEsc={() => {
                setOpen(false);
              }}
              selectedRef={node => setSelectedElement(node)}
            />
          </WBPopup>
        )}
      </>
    );
  },
  {id: 'WBSelect'}
);

export default WBSelect;
